import Container from '@/components/layout/Container';

export default function RichTextEditor({ block, position }) {
  const {
    content,
    add_space_below,
    container_size,
    container_padding,
    background_color_picker
  } = block.rich_text_editor;

  // Utility for padding
  const getPaddingClass = (size) => {
    switch (size) {
      case 'Small':
        return 'py-4';
      case 'Medium':
        return 'standard-padding';
      case 'Large':
        return 'py-12';
      default:
        return 'py-0';
    }
  };

  return (
    <section
      id={`rich_text_editor_${position}`}
      data-name={'rich_text_editor'}
      style={{ backgroundColor: background_color_picker }}
      className={`rich_text_editor ${getPaddingClass(container_padding)}`}
    >
      <Container
        fullPage={container_size && container_size !== 'None'}
        className="px-4"
      >
        <div
          className={`rte ${add_space_below ? `mb-${add_space_below}` : ''}`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Container>
    </section>
  );
}
